module.exports = __webpack_public_path__ + "static/media/3.31a86edf.png";